import axios from "axios";

import {
  authDeviceWithDomainHeader,
  authWithDomainHeader,
} from "../authServices/auth.header";

const API_URL = process.env.VUE_APP_ROOT_API;
class RecordingService {
  // Get Recording List
  async getRecordingList(domain_uuid = null) {
    return await axios
      .get(API_URL + `call-app/media/recording`, {
        headers: domain_uuid
          ? authWithDomainHeader(domain_uuid)
          : authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new RecordingService();
